import type { FaireProductEntity } from "../../entity_types/product";

export const p_5jjw8saam6: FaireProductEntity = {
  token: "p_5jjw8saam6",
  type: "product",
  name: "BRUSH ON ME Pet Facial & Eye Comb",
  brandToken: "b_ewmtw9s8vk",
  brandName: "petora",
  imageUrl:
    "https://cdn.faire.com/fastly/af0c101368c7b0c34c2948749983ce977abe3c839fcecc7a925aa623d24c7ada.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/cd833792915b102f55bcc0a40d5baa683914979836c78f3c6302a65ac7128ec1.png",
    "https://cdn.faire.com/fastly/663ba150a2117cf08ec32d61bfc553f22210a0d5afd28ad79d4bb6e0bded1484.png",
    "https://cdn.faire.com/fastly/1aa84fc99daeb7bc3d89bda415a5d8ee296c57887312947c757a1de4d331bc6d.png",
    "https://cdn.faire.com/fastly/7571070230a0e6d7b674c4227de69ca2907566c64e041bda6c55af5012d90c4c.png",
    "https://cdn.faire.com/fastly/9f97040a96417957617d51c8df215158d0e71797037450003f920da958b1cd90.png",
    "https://cdn.faire.com/fastly/a4459c5b317897a72e0e13415c5b9a990a565a7d1b69137704df0a97dad1d254.png",
    "https://cdn.faire.com/fastly/225a6e3a5cbc2210cf6a3b8871b22b005176f77cc9ba3dc30a44caac48681442.jpeg",
    "https://cdn.faire.com/fastly/f390a7fe4d52a89a635657846692dc6acf307e26f602c181d56292cc8ce08480.png",
  ],
  priceDollars: 6,
  description:
    "* Gentle, Rounded-Tip Design: \n- Protect your pet’s sensitive eyes and face with a comb that features smooth, rounded prongs. It gently lifts away tear crust, mucus, and “eye boogers” without scratching or pulling, making grooming a pain-free experience for your cat or dog.\n\n* Effective Tear Stain Removal: \n- Say goodbye to unsightly tear stains! The fine-tooth stainless steel comb reaches deep to remove gunk and discoloration at the source. Regular use helps prevent new tear stains from forming, keeping your furry friend’s face clean, healthy, and camera-ready.\n\n* For All Breeds & Fur Types: \n- Whether you have a tiny Maltese, a Shih Tzu, a Persian cat, or a larger breed, this eye comb is precisely designed for pets of all sizes and coats. It even doubles as a flea comb to catch small pests – a versatile grooming tool for every pet household.\n\n* Ergonomic Comfort Grip: \n- Enjoy grooming with a comb that’s as comfortable for you as it is for your pet.\n",
  tags: [],
  msrpDollars: 12,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-06T18:02:07.333Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
